/* ============================================================
   Hobby Shop Solution — la pagina /search usa il motore del CRM
   ------------------------------------------------------------
   PERCHE' ESISTE
   La ricerca nativa di Shopify cerca le parole cosi' come sono
   scritte. Chi scrive «separe» non trova «Separè», chi scrive
   «sofa» non trova «Divano», chi scrive «copriletto» non trova
   il plaid. Il motore del CRM, invece, sa gli accenti, i
   sinonimi, i singolari/plurali e ordina per pertinenza misurata.
   Finora quel motore rispondeva SOLO nella tendina del widget:
   premendo Invio il cliente ricadeva sulla ricerca vecchia.

   COME
   A innesto, non a sostituzione: si parte dalla pagina nativa
   gia' stampata e la si rimpiazza solo DOPO che il CRM ha
   risposto davvero. Se il CRM non risponde, o risponde male, o
   il browser e' troppo vecchio, in pagina resta la ricerca di
   Shopify e il cliente non si accorge di niente. Non c'e' un
   momento in cui la pagina e' vuota per colpa nostra.

   QUELLO CHE SI PERDE, DETTO CHIARO
   I filtri e l'ordinamento nativi lavorano sui risultati di
   Shopify, non sui nostri: tenerli accesi sopra una lista
   diversa significherebbe mostrare filtri che non filtrano.
   Si nascondono, e l'ordinamento lo si rifa' qui parlando col
   CRM (vedi il parametro `sort`), che ordina su TUTTI i
   risultati e non solo sui 24 in pagina.
   ============================================================ */

(function () {
  'use strict';

  var CRM = 'https://crm.hobbyshopsolution.com';
  var PER_PAGINA = 24;

  var contenitore = document.getElementById('ProductGridContainer');
  if (!contenitore) return;

  // La domanda la si legge dall'indirizzo, non dal campo di testo:
  // il campo lo si puo' riscrivere senza inviare, l'indirizzo e'
  // quello che il cliente ha davvero chiesto.
  var parametri = new URLSearchParams(window.location.search);
  var domanda = (parametri.get('q') || '').trim();
  if (domanda.length < 2) return;

  // Se il cliente ha usato i filtri nativi (?filter.v.price.gte=...)
  // non si tocca niente: ha scelto di stare dentro la ricerca di
  // Shopify e portarglielo via a meta' strada sarebbe peggio.
  var haFiltriNativi = false;
  parametri.forEach(function (v, k) { if (k.indexOf('filter.') === 0) haFiltriNativi = true; });
  if (haFiltriNativi) return;

  var ordineIniziale = parametri.get('hss_ordine') || 'rilevanza';
  var ORDINI = [
    ['rilevanza', 'Più pertinenti'],
    ['venduti', 'I più venduti'],
    ['prezzo-asc', 'Prezzo crescente'],
    ['prezzo-desc', 'Prezzo decrescente'],
    ['novita', 'Novità']
  ];

  // I filtri vivono nell'indirizzo, col prefisso `hss_` come
  // l'ordinamento: cosi' un link condiviso o un ricaricamento
  // riportano la stessa lista, e non si scontrano mai con i
  // `filter.*` di Shopify (che piu' su fanno ritirare l'innesto).
  //
  // Le marche si separano con «|» e non con la virgola perche' nei
  // nomi delle marche la virgola c'e' davvero: «Zanetti, Cosma & C.».
  //
  // Lo ZERO vale campo vuoto, non «fino a zero euro». Chi scrive 0 nel
  // campo «a» sta azzerando il campo, non chiedendo la merce gratis — e
  // un tetto di zero euro svuota la pagina: provato sul vivo,
  // `prezzoMax=0` su «scrivania» tornava 0 prodotti invece di 125. Lo
  // stesso per il campo «da»: «Da 0 €» e' una targhetta che non dice
  // niente. Il CRM si difende da solo (vedi searchRoutes), questo qui
  // serve perche' la targhetta non compaia e l'indirizzo resti pulito.
  function leggiNumero(chiave) {
    var v = parametri.get(chiave);
    if (v == null || v === '') return null;
    var n = parseFloat(String(v).replace(',', '.'));
    return isFinite(n) && n > 0 ? n : null;
  }

  var filtri = {
    pmin: leggiNumero('hss_pmin'),
    pmax: leggiNumero('hss_pmax'),
    marche: (parametri.get('hss_marca') || '').split('|').filter(function (s) { return s.trim() !== ''; }),
    promo: parametri.get('hss_promo') === '1'
  };

  function filtriAttivi() {
    return filtri.pmin !== null || filtri.pmax !== null || filtri.marche.length > 0 || filtri.promo;
  }

  // ---------- utilità ----------

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var soldi = (function () {
    try {
      var f = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
      return function (n) { return f.format(n); };
    } catch (e) {
      return function (n) { return '€ ' + Number(n).toFixed(2).replace('.', ','); };
    }
  })();

  // Le foto arrivano a piena risoluzione dal CDN di Shopify: una
  // scheda da 300px non ha bisogno di 2048px. `width` si aggiunge
  // rispettando la query che c'e' gia' (le URL del CDN hanno spesso
  // un ?v=... di cache-bust: appiccicare un altro ? la rompe).
  function foto(url, px) {
    if (!url) return '';
    if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/') === -1) return url;
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + px;
  }

  function sessione() {
    try {
      var k = 'hss_search_sid';
      var v = sessionStorage.getItem(k);
      if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem(k, v); }
      return v;
    } catch (e) { return ''; }
  }

  // ---------- lo scheletro della pagina ----------

  var radice = document.createElement('div');
  radice.className = 'hss-ric';
  radice.setAttribute('data-hss-ricerca', '1');

  var testa = document.createElement('div');
  testa.className = 'hss-ric-testa';
  testa.innerHTML =
    '<div>' +
      '<p class="hss-ric-occhiello">Risultati della ricerca</p>' +
      '<h2 class="hss-ric-conteggio" id="hss-ric-conteggio" role="status" aria-live="polite"></h2>' +
    '</div>' +
    '<label class="hss-ric-ordine">Ordina per' +
      '<select id="hss-ric-ordine">' +
        ORDINI.map(function (o) {
          return '<option value="' + o[0] + '"' + (o[0] === ordineIniziale ? ' selected' : '') + '>' + o[1] + '</option>';
        }).join('') +
      '</select>' +
    '</label>';

  // La barra dei filtri nasce spenta e si accende solo quando il CRM
  // manda le voci coi numeri veri: un filtro senza conteggio e' una
  // promessa che non sappiamo di poter mantenere, ed e' esattamente
  // il difetto dei filtri nativi su questa pagina (filtrano la lista
  // di Shopify, non la nostra).
  var barra = document.createElement('div');
  barra.className = 'hss-ric-barra';
  barra.hidden = true;

  var avviso = document.createElement('div');
  avviso.className = 'hss-ric-avviso';
  avviso.hidden = true;

  var griglia = document.createElement('ul');
  griglia.className = 'hss-ric-griglia';
  griglia.setAttribute('role', 'list');

  var piede = document.createElement('div');
  piede.className = 'hss-ric-piede';
  piede.hidden = true;
  piede.innerHTML =
    '<button type="button" class="hss-ric-altri" id="hss-ric-altri">Carica altri prodotti</button>' +
    '<p class="hss-ric-quanti" id="hss-ric-quanti"></p>';

  radice.appendChild(testa);
  radice.appendChild(barra);
  radice.appendChild(avviso);
  radice.appendChild(griglia);
  radice.appendChild(piede);

  // ---------- la scheda prodotto ----------

  function scheda(p) {
    var li = document.createElement('li');
    li.className = 'hss-ric-scheda';

    var bollini = '';
    if (p.discountPct && p.discountPct >= 5) {
      bollini += '<span class="hss-ric-bollino hss-ric-bollino--sconto">-' + p.discountPct + '%</span>';
    }
    if (p.isNew) {
      bollini += '<span class="hss-ric-bollino hss-ric-bollino--nuovo">Novità</span>';
    }

    var immagine = foto(p.image, 500);
    var blocFoto = immagine
      ? '<img src="' + esc(immagine) + '" alt="' + esc(p.title) + '" loading="lazy" decoding="async">'
      : '<span aria-hidden="true" style="color:#b3bdb2;font-size:12px">Foto non disponibile</span>';

    var prezzi = '';
    if (p.price != null) {
      prezzi = '<span class="hss-ric-prezzo">' + soldi(p.price) + '</span>';
      if (p.compareAtPrice && p.compareAtPrice > p.price) {
        prezzi += '<span class="hss-ric-prezzo-vecchio">' + soldi(p.compareAtPrice) + '</span>';
      }
    }

    li.innerHTML =
      '<a class="hss-ric-foto' + (immagine ? '' : ' hss-ric-foto--vuota') + '" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
        (bollini ? '<span class="hss-ric-bollini">' + bollini + '</span>' : '') +
        blocFoto +
      '</a>' +
      '<div class="hss-ric-corpo">' +
        (p.vendor ? '<p class="hss-ric-marca">' + esc(p.vendor) + '</p>' : '') +
        '<h3 class="hss-ric-nome"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
        '<div class="hss-ric-prezzi">' + prezzi + '</div>' +
      '</div>';

    // Il click si registra nel CRM come lo registra la tendina:
    // serve a sapere quali risposte il cliente apre davvero, ed e'
    // quello che fa migliorare il punteggio nelle prossime sessioni.
    li.addEventListener('click', function () {
      try {
        fetch(CRM + '/api/widget-pilot/search/track-click', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query: domanda, handle: p.handle, sessionId: sessione() }),
          keepalive: true
        }).catch(function () {});
      } catch (e) {}
    }, { passive: true });

    return li;
  }

  // ---------- il testo del conteggio e degli avvisi ----------

  function scriviConteggio(dati) {
    var n = dati.totalCount || 0;
    var parole = dati.query || domanda;
    var testo = n === 0
      ? 'Nessun prodotto per <em>' + esc(parole) + '</em>'
      : (n === 1 ? '1 prodotto per <em>' : n + ' prodotti per <em>') + esc(parole) + '</em>';
    var el = document.getElementById('hss-ric-conteggio');
    if (el) el.innerHTML = testo;
    // Il conteggio nativo (#ProductCountDesktop) NON si aggiorna: va
    // nascosto insieme ai filtri, e un elemento nascosto esce anche
    // dall'albero di accessibilita', quindi riscriverlo non lo farebbe
    // leggere a nessuno. Il conteggio accessibile e' il nostro, che
    // sta in un <h2 role="status" aria-live="polite">.
  }

  function scriviAvviso(dati) {
    var pezzi = [];

    if (dati.autoCorrected && dati.originalQuery) {
      pezzi.push('Nessun risultato per <strong>' + esc(dati.originalQuery) + '</strong>: ' +
        'stiamo mostrando i prodotti per <strong>' + esc(dati.query) + '</strong>.');
    } else if (dati.relaxedQuery) {
      // Onesta' sui ripieghi: se la frase intera non dava niente e
      // abbiamo cercato con meno parole, lo si dice. Prima il
      // cliente vedeva risultati vagamente attinenti e non capiva
      // perche'.
      var esatti = dati.exactCount || 0;
      pezzi.push(esatti > 0
        ? 'I primi ' + esatti + ' corrispondono alla tua ricerca. Sotto, i prodotti per <strong>' + esc(dati.relaxedQuery) + '</strong>.'
        : 'Non abbiamo prodotti per la frase intera: ecco quelli per <strong>' + esc(dati.relaxedQuery) + '</strong>.');
    } else if (dati.suggestion) {
      pezzi.push('Cercavi forse <a href="' + esc(window.location.pathname) + '?q=' + encodeURIComponent(dati.suggestion) + '">' + esc(dati.suggestion) + '</a>?');
    }

    if (pezzi.length === 0) { avviso.hidden = true; return; }
    avviso.innerHTML = pezzi.join(' ');
    avviso.hidden = false;
  }

  // ---------- la barra dei filtri ----------

  // I pannelli sono <details>: aprire e chiudere e' del browser, non
  // mio, quindi funzionano da tastiera e senza JS. L'unica cosa che
  // aggiungo e' chiuderli quando si clicca fuori.
  function disegnaFiltri(dati) {
    var f = dati.filtri;
    // Le voci arrivano solo con la prima pagina. Su «carica altri»
    // non ci sono, e la barra NON va ridisegnata: cancellerebbe la
    // scelta del cliente a meta' scorrimento.
    if (!f) return;

    var min = f.prezzoMinimo, max = f.prezzoMassimo;
    // Un filtro prezzo su un intervallo che non esiste (tutti i
    // prodotti allo stesso prezzo, o un solo risultato) e' una leva
    // finta: non si mostra.
    var haPrezzo = min != null && max != null && max > min;

    // Una marca scelta deve restare visibile anche se e' rara e cade
    // fuori dalle prime dodici: altrimenti il cliente vede la lista
    // filtrata e non trova piu' la casella per togliere il filtro.
    var marche = (f.marche || []).slice();
    filtri.marche.forEach(function (nome) {
      var c = marche.some(function (m) { return m.nome.toLowerCase() === nome.toLowerCase(); });
      if (!c) marche.push({ nome: nome, quanti: null });
    });

    var haMarche = marche.length > 1;
    var haPromo = (f.inPromozione || 0) > 0;

    if (!haPrezzo && !haMarche && !haPromo) { barra.hidden = true; return; }

    var gruppi = '';

    if (haPrezzo) {
      var dentro = filtri.pmin !== null || filtri.pmax !== null;
      gruppi +=
        '<details class="hss-ric-f' + (dentro ? ' hss-ric-f--on' : '') + '">' +
          '<summary>Prezzo' + (dentro ? '<span class="hss-ric-punto"></span>' : '') + '</summary>' +
          '<div class="hss-ric-pan">' +
            '<div class="hss-ric-dadue">' +
              '<label>Da<input type="number" inputmode="decimal" class="hss-ric-num" data-n="pmin" ' +
                'min="' + min + '" max="' + max + '" placeholder="' + min + '" ' +
                'value="' + (filtri.pmin !== null ? filtri.pmin : '') + '" aria-label="Prezzo minimo in euro"></label>' +
              '<label>A<input type="number" inputmode="decimal" class="hss-ric-num" data-n="pmax" ' +
                'min="' + min + '" max="' + max + '" placeholder="' + max + '" ' +
                'value="' + (filtri.pmax !== null ? filtri.pmax : '') + '" aria-label="Prezzo massimo in euro"></label>' +
            '</div>' +
            '<p class="hss-ric-nota">Su questa ricerca: da ' + soldi(min) + ' a ' + soldi(max) + '</p>' +
            '<button type="button" class="hss-ric-applica" data-az="prezzo">Applica</button>' +
          '</div>' +
        '</details>';
    }

    if (haMarche) {
      var scelte = filtri.marche.map(function (s) { return s.toLowerCase(); });
      gruppi +=
        '<details class="hss-ric-f' + (scelte.length ? ' hss-ric-f--on' : '') + '">' +
          '<summary>Marca' + (scelte.length ? '<span class="hss-ric-punto">' + scelte.length + '</span>' : '') + '</summary>' +
          '<div class="hss-ric-pan hss-ric-pan--lista">' +
            marche.map(function (m) {
              var on = scelte.indexOf(String(m.nome).toLowerCase()) !== -1;
              return '<label class="hss-ric-voce">' +
                '<input type="checkbox" data-marca="' + esc(m.nome) + '"' + (on ? ' checked' : '') + '>' +
                '<span class="hss-ric-voce-nome">' + esc(m.nome) + '</span>' +
                // Il numero manca solo per una marca scelta che e'
                // caduta fuori dalle prime dodici: meglio niente che
                // un numero inventato.
                (m.quanti != null ? '<span class="hss-ric-voce-n">' + m.quanti + '</span>' : '') +
              '</label>';
            }).join('') +
          '</div>' +
        '</details>';
    }

    if (haPromo) {
      gruppi += '<button type="button" class="hss-ric-pill' + (filtri.promo ? ' hss-ric-pill--on' : '') + '" ' +
        'data-az="promo" aria-pressed="' + (filtri.promo ? 'true' : 'false') + '">' +
        'In offerta <span class="hss-ric-pill-n">' + f.inPromozione + '</span></button>';
    }

    // Le scelte fatte, ripetute in chiaro con la loro crocetta. Serve
    // su mobile, dove i pannelli sono chiusi e altrimenti non si
    // vedrebbe PERCHE' la lista e' corta.
    var chip = [];
    if (filtri.pmin !== null || filtri.pmax !== null) {
      chip.push(['prezzo', filtri.pmin !== null && filtri.pmax !== null
        ? 'Da ' + soldi(filtri.pmin) + ' a ' + soldi(filtri.pmax)
        : (filtri.pmin !== null ? 'Da ' + soldi(filtri.pmin) : 'Fino a ' + soldi(filtri.pmax))]);
    }
    filtri.marche.forEach(function (m) { chip.push(['marca:' + m, m]); });
    if (filtri.promo) chip.push(['promo', 'In offerta']);

    var attivi = chip.length
      ? '<div class="hss-ric-attivi">' +
          chip.map(function (c) {
            return '<button type="button" class="hss-ric-chip" data-via="' + esc(c[0]) + '">' +
              esc(c[1]) + '<span aria-hidden="true">×</span>' +
              '<span class="hss-ric-vocale"> — togli questo filtro</span></button>';
          }).join('') +
          '<button type="button" class="hss-ric-azzera" data-az="azzera">Azzera tutto</button>' +
        '</div>'
      : '';

    barra.innerHTML = '<div class="hss-ric-gruppi">' + gruppi + '</div>' + attivi;
    barra.hidden = false;
  }

  // ---------- i consigli del riquadro vuoto ----------
  //
  // Prima qui c'erano sei parole fisse: divano, tavolo, sedie,
  // specchio, letto, lampadario. Tutte e sei di arredo. Chi cercava
  // «moroccanoil» — uno shampoo che non trattiamo — si sentiva
  // rispondere con un divano, e il negozio ha nove reparti.
  //
  // Ora si chiedono al CRM le ricerche piu' fatte DAGLI ALTRI
  // CLIENTI: il CRM tiene solo quelle che portano davvero a dei
  // prodotti (vedi il commento lungo sull'endpoint `trending`), cosi'
  // un consiglio non puo' essere a sua volta un vicolo cieco.
  //
  // Il ripiego resta scritto qui, ma cambia natura: non sei mobili,
  // sei reparti diversi. Contati a mano sul motore vero prima di
  // metterli: scarpe 733 prodotti, giardino 524, casalinghi 379,
  // ferramenta 260, illuminazione 233, profumo 98. Serve quando il
  // CRM non risponde o quando le ricerche vere sono troppo poche —
  // il riquadro non deve MAI restare senza una via d'uscita.
  var RIPIEGO = ['scarpe', 'profumo', 'casalinghi', 'ferramenta', 'illuminazione', 'giardino'];

  function chiediConsigli() {
    return fetch(CRM + '/api/widget-pilot/search/trending?limit=10', { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return (j && j.trending) || []; })
      .catch(function () { return []; });
  }

  // Dalle parole del CRM piu' il ripiego si tengono sei voci buone.
  function scegliConsigli(dalCrm) {
    var scelte = [];
    var visti = {};
    var bassa = domanda.toLowerCase();
    function prova(w) {
      w = String(w == null ? '' : w).trim().toLowerCase();
      if (w.length < 3 || scelte.length >= 6) return;
      // Riproporre la parola che il cliente ha appena scritto (o un
      // suo pezzo) vuol dire rimandarlo nel vuoto da cui viene.
      if (w === bassa || w.indexOf(bassa) === 0 || bassa.indexOf(w) === 0) return;
      // «pannelli» e «pannello» sono un consiglio solo e occuperebbero
      // due dei sei posti: si tiene il primo che arriva, che e' il piu'
      // cercato.
      var inizio = w.slice(0, 5);
      if (visti[inizio]) return;
      visti[inizio] = true;
      scelte.push(w);
    }
    dalCrm.forEach(prova);
    RIPIEGO.forEach(prova);
    return scelte;
  }

  function disegnaConsigli(dove, parole) {
    if (!dove) return;
    dove.innerHTML = parole.map(function (w) {
      return '<a class="hss-ric-suggerimento" href="' + esc(window.location.pathname) +
        '?q=' + encodeURIComponent(w) + '">' + esc(w) + '</a>';
    }).join('');
  }

  function scriviVuoto() {
    griglia.innerHTML = '';
    piede.hidden = true;
    var box = document.createElement('div');
    box.className = 'hss-ric-vuoto';

    // Vuoto per i filtri e vuoto perche' non trattiamo il prodotto
    // sono due cose diverse, e la via d'uscita e' diversa: nel primo
    // caso i prodotti ci sono, basta allargare.
    if (filtriAttivi()) {
      box.innerHTML =
        '<h2>Nessun prodotto con questi filtri</h2>' +
        '<p>Per «' + esc(domanda) + '» abbiamo dei prodotti, ma nessuno rientra nei filtri che hai scelto. ' +
        'Prova ad allargare il prezzo o a togliere una marca.</p>' +
        '<div class="hss-ric-suggerimenti">' +
          '<button type="button" class="hss-ric-suggerimento" data-az="azzera">Togli tutti i filtri</button>' +
        '</div>';
    } else {
      box.innerHTML =
        '<h2>Non abbiamo trovato niente per «' + esc(domanda) + '»</h2>' +
        '<p>Può essere un prodotto che non trattiamo, o una parola scritta in un modo che non riconosciamo. ' +
        'Prova con una parola sola e più generica, oppure scrivici: ti rispondiamo noi.</p>' +
        '<div class="hss-ric-suggerimenti" data-consigli></div>';
      // Il ripiego si disegna SUBITO, i consigli veri lo sostituiscono
      // quando (e se) arrivano: il messaggio e una via d'uscita devono
      // stare in pagina senza aspettare una seconda chiamata.
      var dove = box.querySelector('[data-consigli]');
      disegnaConsigli(dove, scegliConsigli([]));
      chiediConsigli().then(function (parole) {
        if (!parole.length) return;
        var lista = scegliConsigli(parole);
        if (lista.length) disegnaConsigli(dove, lista);
      });
    }
    radice.appendChild(box);
  }

  // ---------- il dialogo col CRM ----------

  var stato = { offset: 0, ordine: ordineIniziale, mostrati: 0, totale: 0, inCorso: false };

  function chiedi(offset, ordine) {
    var u = CRM + '/api/widget-pilot/search?q=' + encodeURIComponent(domanda) +
      '&limit=' + PER_PAGINA + '&offset=' + offset + '&sort=' + encodeURIComponent(ordine) +
      '&sessionId=' + encodeURIComponent(sessione());
    if (filtri.pmin !== null) u += '&prezzoMin=' + encodeURIComponent(filtri.pmin);
    if (filtri.pmax !== null) u += '&prezzoMax=' + encodeURIComponent(filtri.pmax);
    if (filtri.marche.length) u += '&marca=' + encodeURIComponent(filtri.marche.join('|'));
    if (filtri.promo) u += '&promo=1';
    return fetch(u, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  // L'indirizzo si riscrive senza ricaricare, come per l'ordinamento:
  // il tasto «indietro» non deve rifare venti passi fra un filtro e
  // l'altro, ma il link copiato dalla barra deve funzionare.
  function scriviIndirizzo() {
    try {
      var p = new URLSearchParams(window.location.search);
      if (filtri.pmin !== null) p.set('hss_pmin', filtri.pmin); else p.delete('hss_pmin');
      if (filtri.pmax !== null) p.set('hss_pmax', filtri.pmax); else p.delete('hss_pmax');
      if (filtri.marche.length) p.set('hss_marca', filtri.marche.join('|')); else p.delete('hss_marca');
      if (filtri.promo) p.set('hss_promo', '1'); else p.delete('hss_promo');
      history.replaceState(null, '', window.location.pathname + (p.toString() ? '?' + p.toString() : ''));
    } catch (e) {}
  }

  // Un cambio di filtro ricomincia da capo: `offset` a zero. Tenerlo
  // dov'era mostrerebbe la pagina 3 di una lista che ora ne ha una.
  function riparti() {
    if (stato.inCorso) return;
    stato.inCorso = true;
    stato.offset = 0;
    scriviIndirizzo();
    radice.classList.add('hss-ric--carica');
    scheletri(PER_PAGINA);
    chiedi(0, stato.ordine).then(function (dati) {
      radice.classList.remove('hss-ric--carica');
      disegna(dati, false);
    }).catch(function (e) {
      // Qui NON si ritira l'innesto: la pagina nativa non conosce
      // questi filtri e il cliente si ritroverebbe una lista che non
      // ha chiesto. Si rimette su quello che c'era e lo si dice.
      radice.classList.remove('hss-ric--carica');
      griglia.innerHTML = '';
      avviso.innerHTML = 'Non riusciamo a filtrare in questo momento. <a href="' +
        esc(window.location.pathname) + '?q=' + encodeURIComponent(domanda) + '">Riprova senza filtri</a>.';
      avviso.hidden = false;
      if (window.console) console.warn('[hss-ricerca] filtro non applicato:', e && e.message);
    }).then(function () { stato.inCorso = false; });
  }

  function disegna(dati, accoda) {
    // Gli appuntati (scelti a mano nel CRM per questa domanda)
    // vanno in testa, e solo sulla prima pagina.
    var lista = (dati.pinned || []).concat(dati.products || []);

    if (!accoda) {
      griglia.innerHTML = '';
      stato.mostrati = 0;
      var vecchio = radice.querySelector('.hss-ric-vuoto');
      if (vecchio) vecchio.remove();
    }

    var pezzo = document.createDocumentFragment();
    lista.forEach(function (p) { pezzo.appendChild(scheda(p)); });
    griglia.appendChild(pezzo);

    stato.mostrati += lista.length;
    stato.totale = dati.totalCount || stato.mostrati;

    scriviConteggio(dati);
    if (!accoda) { scriviAvviso(dati); disegnaFiltri(dati); }

    if (stato.mostrati === 0) { scriviVuoto(); return; }

    var restano = stato.totale - stato.mostrati;
    piede.hidden = !(dati.hasMore && restano > 0);
    var quanti = document.getElementById('hss-ric-quanti');
    if (quanti) {
      quanti.textContent = restano > 0
        ? stato.mostrati + ' di ' + stato.totale + ' prodotti'
        : 'Hai visto tutti i ' + stato.totale + ' prodotti';
    }
  }

  function scheletri(n) {
    griglia.innerHTML = '';
    for (var i = 0; i < n; i++) {
      var li = document.createElement('li');
      li.className = 'hss-ric-scheletro';
      griglia.appendChild(li);
    }
  }

  // I pezzi nativi che il nostro innesto sostituisce. Si spengono
  // subito e si riaccendono se il CRM non risponde: la lista e' una
  // sola, usata nei due versi, cosi' non si puo' sbagliare a
  // rimetterli a posto.
  var NATIVI = [
    '#main-search-filters',
    '.template-search__results',
    'facet-filters-form',
    '.facets-container'
  ];

  function nativi(acceso) {
    NATIVI.forEach(function (s) {
      var el = document.querySelector(s);
      if (el) el.hidden = !acceso;
    });
    var verticale = document.querySelector('.facets-vertical');
    if (verticale) {
      // La colonna dei filtri nativi impone una griglia a due
      // colonne al contenitore: lasciata accesa senza i filtri
      // dentro, la nostra griglia resterebbe schiacciata a destra.
      verticale.classList.toggle('facets-vertical', acceso);
      verticale.classList.toggle('page-width', acceso);
    }
  }

  function subentra() {
    nativi(false);
    if (!radice.parentNode) contenitore.appendChild(radice);
  }

  function ritirati() {
    nativi(true);
    if (radice.parentNode) radice.parentNode.removeChild(radice);
  }

  // ---------- avvio ----------

  // Si prende la pagina subito, con gli scheletri al posto delle
  // schede. Aspettare la risposta per poi sostituire darebbe al
  // cliente due liste diverse una dopo l'altra: prima quella vecchia
  // e sbagliata, poi la nostra. Meglio un'attesa onesta.
  subentra();
  scheletri(PER_PAGINA);
  radice.classList.add('hss-ric--carica');

  chiedi(0, stato.ordine).then(function (dati) {
    // Una query dirottata dal CRM (es. «resi» → la pagina dei resi)
    // vale anche qui, non solo nella tendina.
    if (dati.redirect) { window.location.replace(dati.redirect); return; }
    radice.classList.remove('hss-ric--carica');
    disegna(dati, false);
  }).catch(function (e) {
    // Si torna alla pagina nativa esattamente come era. E' il punto
    // di tutto questo innesto: in caso di guasto il cliente vede
    // comunque una ricerca che funziona, solo meno brava.
    ritirati();
    if (window.console) console.warn('[hss-ricerca] motore CRM non raggiungibile, resta la ricerca nativa:', e && e.message);
  });

  // ---------- carica altri ----------

  piede.addEventListener('click', function (ev) {
    var b = ev.target.closest('#hss-ric-altri');
    if (!b || stato.inCorso) return;
    stato.inCorso = true;
    b.disabled = true;
    b.textContent = 'Carico…';
    chiedi(stato.mostrati, stato.ordine).then(function (dati) {
      stato.offset = stato.mostrati;
      disegna(dati, true);
    }).catch(function () {
      var quanti = document.getElementById('hss-ric-quanti');
      if (quanti) quanti.textContent = 'Non è stato possibile caricare altri prodotti. Riprova.';
    }).then(function () {
      stato.inCorso = false;
      b.disabled = false;
      b.textContent = 'Carica altri prodotti';
    });
  });

  // ---------- cambio ordinamento ----------

  testa.addEventListener('change', function (ev) {
    if (ev.target.id !== 'hss-ric-ordine' || stato.inCorso) return;
    var nuovo = ev.target.value;
    stato.ordine = nuovo;
    stato.inCorso = true;
    radice.classList.add('hss-ric--carica');
    scheletri(PER_PAGINA);

    // L'ordine scelto finisce nell'indirizzo: se il cliente apre un
    // prodotto e torna indietro, lo ritrova come l'aveva lasciato.
    try {
      var p = new URLSearchParams(window.location.search);
      if (nuovo === 'rilevanza') p.delete('hss_ordine'); else p.set('hss_ordine', nuovo);
      history.replaceState(null, '', window.location.pathname + (p.toString() ? '?' + p.toString() : ''));
    } catch (e) {}

    chiedi(0, nuovo).then(function (dati) {
      disegna(dati, false);
    }).catch(function () {
      griglia.innerHTML = '';
      avviso.innerHTML = 'Non è stato possibile riordinare i risultati. Riprova fra un istante.';
      avviso.hidden = false;
    }).then(function () {
      stato.inCorso = false;
      radice.classList.remove('hss-ric--carica');
      window.scrollTo({ top: radice.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
    });
  });

  // ---------- i filtri ----------

  // Un solo ascoltatore su tutta la radice invece di uno per comando:
  // la barra si ridisegna a ogni risposta, e gli ascoltatori attaccati
  // ai bottoni morirebbero con loro. Qui dentro ci finisce anche il
  // «togli tutti i filtri» del riquadro vuoto, che sta fuori barra.
  radice.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-az], [data-via]');
    if (!b || !radice.contains(b)) return;
    var az = b.getAttribute('data-az');
    var via = b.getAttribute('data-via');

    if (az === 'prezzo') {
      var gmin = barra.querySelector('[data-n="pmin"]');
      var gmax = barra.querySelector('[data-n="pmax"]');
      var vmin = gmin && gmin.value !== '' ? parseFloat(gmin.value) : null;
      var vmax = gmax && gmax.value !== '' ? parseFloat(gmax.value) : null;
      if (vmin !== null && !isFinite(vmin)) vmin = null;
      if (vmax !== null && !isFinite(vmax)) vmax = null;
      // Zero = campo vuoto (vedi leggiNumero). Va azzerato PRIMA dello
      // scambio qui sotto, altrimenti «da 50 a 0» diventerebbe «da 0 a
      // 50», che non e' quello che il cliente ha chiesto.
      if (vmin === 0) vmin = null;
      if (vmax === 0) vmax = null;
      // Da 500 a 100 non e' un intervallo: se il cliente li ha
      // scambiati li rimetto in ordine invece di dirgli che ha
      // sbagliato — e' quello che intendeva.
      if (vmin !== null && vmax !== null && vmin > vmax) { var t = vmin; vmin = vmax; vmax = t; }
      filtri.pmin = vmin;
      filtri.pmax = vmax;
      riparti();
      return;
    }

    if (az === 'promo') { filtri.promo = !filtri.promo; riparti(); return; }

    if (az === 'azzera') {
      filtri.pmin = null; filtri.pmax = null; filtri.marche = []; filtri.promo = false;
      riparti();
      return;
    }

    if (via === 'prezzo') { filtri.pmin = null; filtri.pmax = null; riparti(); return; }
    if (via === 'promo') { filtri.promo = false; riparti(); return; }
    if (via && via.indexOf('marca:') === 0) {
      var nome = via.slice(6).toLowerCase();
      filtri.marche = filtri.marche.filter(function (m) { return m.toLowerCase() !== nome; });
      riparti();
      return;
    }
  });

  barra.addEventListener('change', function (ev) {
    var c = ev.target.closest('[data-marca]');
    if (!c) return;
    var nome = c.getAttribute('data-marca');
    var basso = nome.toLowerCase();
    if (c.checked) {
      if (filtri.marche.every(function (m) { return m.toLowerCase() !== basso; })) filtri.marche.push(nome);
    } else {
      filtri.marche = filtri.marche.filter(function (m) { return m.toLowerCase() !== basso; });
    }
    riparti();
  });

  // Invio nei due campi del prezzo vale «Applica»: nessuno si aspetta
  // di dover cercare il bottone dopo aver battuto un numero.
  barra.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' || !ev.target.closest('.hss-ric-num')) return;
    ev.preventDefault();
    var b = barra.querySelector('[data-az="prezzo"]');
    if (b) b.click();
  });

  // Cliccare fuori chiude i pannelli aperti. Senza questo restano
  // aperti sopra la griglia e coprono la prima riga di schede.
  document.addEventListener('click', function (ev) {
    var dentro = ev.target.closest('.hss-ric-f');
    var aperti = barra.querySelectorAll('details[open]');
    for (var i = 0; i < aperti.length; i++) {
      if (aperti[i] !== dentro) aperti[i].open = false;
    }
  });
})();
